import React, { createContext, useContext } from "react";
import Cookies from "js-cookie";

import { cookies } from "api/_defaults/cookies";
import { Navigate, useLocation } from "react-router-dom";

const Context = createContext({});

export function useToken() {
    return useContext(Context);
}

export function AuthContext(props) {

    const userId = Cookies.get(cookies.user);
    const location = useLocation();

    const isLoginPage = location.pathname === '/user/login' || location.pathname === '/user/signup';

    if (!userId && !isLoginPage) {
        return <Navigate to={`/user/login`} replace/>
    }

    return (
        <Context.Provider value={{ token: userId }}>

            {props.children}

        </Context.Provider>
    )
}